import { __read } from "tslib";
import generateTicks from '../generate-ticks';
import { Orientation } from '../../../../types';
export var generateRuler = function (_a) {
    var x = _a.x, y = _a.y, tickSize = _a.tickSize, scale = _a.scale, orientation = _a.orientation, scaleSettings = _a.scaleSettings;
    var _b = __read(scale.range(), 2), scaleStart = _b[0], scaleEnd = _b[1];
    var _c = generateTicks({
        x: x,
        y: y,
        tickSize: tickSize,
        scale: scale,
        scaleSettings: scaleSettings,
        orientation: orientation,
    }), ticks = _c.ticks, ticksPrecision = _c.ticksPrecision;
    var line;
    if (orientation === Orientation.HORIZONTAL) {
        line = {
            x1: scaleStart,
            x2: scaleEnd,
            y1: y,
            y2: y,
        };
    }
    else {
        line = {
            x1: x,
            x2: x,
            y1: scaleStart,
            y2: scaleEnd,
        };
    }
    return {
        line: line,
        ticks: ticks,
        ticksPrecision: ticksPrecision,
    };
};
export default generateRuler;
